<script>
    import AccountHeader from "../../components/account/AccountHeader.svelte";
    import AccountNav from "../../components/account/AccountNav.svelte";
    import {API_URL} from "../../../env";
    import Error from "../../placeholders/Error.svelte";
    import Loading from "../../placeholders/ContentLoading.svelte";
    import OrderProduct from "../../components/account/orders/OrderProduct.svelte";
    import getFormattedPriceFromOrder from "../../lib/getFormattedPriceFromOrder";
    import getFormattedDate from "../../lib/getFormattedDate";
    import getFormattedPhone from "../../lib/getFormattedPhone";
    import checkLoginValidity from "../../lib/checkLoginValidity";
    import {push, replace} from "svelte-spa-router";
    import {userData} from "../../js/stores";
    import {addAlert} from "../../js/alert";

    window.scrollTo(0, 0);
    if ($userData === null) replace("/?m=prihlasit-sa")
    export let params = {}

    let data = fetchData()

    async function fetchData() {
        const res = await fetch(API_URL + '/users/orders/' + params.id, {
            method: 'GET',
            credentials: "include",
        })
        if (checkLoginValidity(res.status)) return await push("/?m=prihlasit-sa");
        let body = await res.json()
        return body
    }


    let isDownloading = false
    async function downloadInvoice() {
        isDownloading = true

        fetch(API_URL + '/files/getInvoice/' + params.id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
        })
        .then(response => response.blob())
        .then(response => {
            const blob = new Blob([response], {type: 'application/pdf'});
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "faktura-"+ params.id +".pdf";
            document.body.appendChild(a);
            a.click();
            isDownloading = false;
        })
        .catch(() => {
            addAlert("danger", "Chyba", "Pri sťahovaní faktúry sa vyskytla chyba.")
            isDownloading = false
        });
    }
</script>

<section class="container" id="account">
    <AccountHeader/>

    <div class="account">

        <AccountNav/>

        {#await data}
            <Loading/>
        {:then data}
            <div class="account-content">
                <h3>OBJEDNÁVKA #1392 <a href="#/ucet/objednavky" class="float-right"><i class="fas fa-fw fa-arrow-left"></i>SPÄŤ NA SÚHRN</a></h3>
                <div class="order-info">
                    <div class="row">
                        <div class="col-sm-6 col-md-4 col-xl-3">
                            <h4>Doručovacia adresa</h4>
                            <p>{data.name} {data.surname}</p>
                            <p>{data.street}</p>
                            <p>{data.zip}, {data.city}</p>
                            <p>{data.country}</p>
                            <br/>
                            <p>{data.email}</p>
                            <p>{getFormattedPhone(data.phone)}</p>
                        </div>
                        <div class="col-sm-6 col-md-4 col-xl-3">
                            {#if !!data.billing_street || !!data.company}
                                <h4>Fakturačné údaje</h4>
                                {#if !!data.company}
                                    <p>{(data.company)? data.company : ""}</p>
                                    <p><b>IČO:</b> {data.ico}</p>
                                    {#if data.dic?.length > 0}
                                        <p><b>DIČ:</b> {data.dic}</p>
                                    {/if}
                                    {#if data.ic_dph?.length > 0}
                                        <p><b>IČ DPH:</b> {data.ic_dph}</p>
                                    {/if}
                                    <br/>
                                {/if}
                                {#if !!data.billing_street}
                                    <p>{data.billing_street || ''}</p>
                                    <p>{data.billing_zip + ','  || ''} {data.billing_city || ''}</p>
                                    <p>{data.billing_country || ''}</p>
                                {/if}
                            {/if}
                        </div>
                        <div class="col-sm-6 col-md-4 col-xl-3">
                            <h4>Detaily objednávky</h4>
                            <p>Vytvorená: <b>{getFormattedDate(data.created)}</b></p>
                            <p>Celková cena: <b>{getFormattedPriceFromOrder(data)}€</b></p>
                            <p>Počet položiek: <b>{data.products.reduce((a, v) => { return a + v.product_quantity }, 0)}ks</b></p>
                        </div>
                        <div class="col-xl-3 mt-4 mt-xl-0 d-flex flex-column align-items-center justify-content-center">
                            <div class="order-state">
                                <div class="state-item">
                                    <i class="far fa-fw fa-{data.tag.icon || 'check-circle'}"></i>
                                </div>
                                <div class="state-text">
                                    <h5>Aktuální stav</h5>
                                    <span>{data.tag.name || ''}</span>
                                </div>
                            </div>
                            <button type="button" class="btn btn-slate-50" on:click={downloadInvoice}>
                                STIAHNÚŤ FAKTÚRU
                                {#if isDownloading}
                                    <i class="fas fa-fw fa-spinner-third fa-spin ml-2"></i>
                                {:else}
                                    <i class="fas fa-fw fa-download ml-2"></i>
                                {/if}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="order-products">
                    {#each data.products as product}
                        <OrderProduct
                                data={product}
                        />
                    {/each}
                </div>
                <div class="order-payment">
                    <div class="row">
                        <div class="col-lg-6 col-xl-8">
                            <h4>Platobná metóda</h4>
                            {#if !!data.bank_transfer}
                                <p>Bankový prevod</p>
                            {:else}
                                {#if !!data.transport}
                                    <p>Dobierka</p>
                                {:else}
                                    <p>Pri prevzatí</p>
                                {/if}
                            {/if}
                        </div>
                        <div class="col-lg-6 col-xl-4 mt-4 mt-lg-0">
                            <div class="payment-info">
                                <p><span>Dobierka</span><span>{((data.cash_on_delivery_fee === 0 && !data.bank_transfer)? 1.5 : data.cash_on_delivery_fee)?.toFixed(2)}€</span></p>
                                <p><span>Cena dopravy</span><span>{data.transport_fee?.toFixed(2)}€</span></p>
                                <p><span>Hodnota objednávky</span><span>{data.products.reduce((a, v) => { return a + (v.product_price * v.product_quantity) }, 0)?.toFixed(2)}€</span></p>
                                <p><span>Celkom<small>s DPH</small></span><span>{getFormattedPriceFromOrder(data)}€</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {:catch error}
            <Error/>
        {/await}
    </div>
</section>

<style>
    .order-info {
        border-bottom: 1px solid var(--color-slate-200);
        padding-bottom: 2rem;
        margin-bottom: 1.5rem;
    }
    .order-info h4 {
        font-size: 1.1rem;
        margin-bottom: 1rem;
    }
    .order-info p {
        margin: 0 !important;
    }

    .order-info .order-state {
        display: flex;
        gap: 1rem;
        margin-bottom: 1rem;
    }
    .order-info .order-state .state-item {
        height: 2.5rem;
        width: 2.5rem;
        border-radius: 50%;
        border: 1px solid var(--color-slate-200);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .order-info .order-state .state-text {
        display: flex;
        flex-direction: column;
    }
    .order-info .order-state .state-text h5 {
        color: var(--color-slate-700);
    }
    .order-info .order-state .state-text span {
        color: var(--color-slate-500);
    }
    .order-products {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid var(--color-slate-200);
    }


    .order-payment {
        padding: 1.5rem 0;
        border-bottom: 1px solid #0000001A;
    }
    .order-payment h4 {
        font-size: 1.1rem;
        margin-bottom: 1rem;
    }
    .order-payment p {
        margin: 0 !important;
        width: 100%;
    }
    .order-payment .payment-info {
        text-align: right;
        font-size: 1.1rem;
    }
    .order-payment .payment-info p {
        display: flex;
        justify-content: space-between;
    }
    .order-payment .payment-info p:last-of-type {
        margin-top: 1rem !important;
        color: var(--color-secondary) !important;
    }
    .order-payment .payment-info p:last-of-type span:first-of-type {
        font-weight: 700;
    }
    .order-payment .payment-info p:last-of-type span:first-of-type small {
        font-weight: 400;
        display: block;
        text-align: left;
    }
</style>